import React, { Component } from "react";
import AgGridTable from "../../../components/common/agGridTable";
import ReadAxios from "../../../components/axiosComponent/read";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import {
  successAlertDispatcher,
  errorAlertDispatcher,
} from "../../../redux/actions/alertAction";
import { isEmpty } from "lodash";
import { FEATURES, canAddRadarAndSpeedUserKeysInVendorMaster, LOCAL_STORAGE } from "../../../utils/constant";
import RateChart from './rateChart';
import { aesDecrypt } from "../../../utils/commonFunctionalities";
class Vendor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowData: [],
      loadingData: true,
      transporterMasterId: 0
    };
  }

  componentDidMount() {
    ReadAxios({ url: "transporterMaster" })
      .then(async(dataArray) => {
        if(dataArray?.data?.resultSet?.length){
          for(let data of dataArray.data.resultSet){
            if(data.companyPan) data.companyPan = await aesDecrypt(data.companyPan)
          }
          this.setStateRowData(dataArray.data.resultSet);
        }else{
          this.setState({ loadingData: false, rowData: [] })
        }
      })
      .catch((err) => {
        console.log(err);
        this.setState({ loadingData: false, rowData: [] });
      });
  }

  setStateRowData = (dataArray) => {
    let result = dataArray.map((item, index) => {
      return {
        ...item,
        transporterType: "Transporter",
      };
    });
    this.setState({ loadingData: false, rowData: result });
  };

  onCellClicked = (rowData) => {
    if (this.props.permissions.TA_VENDOR_MASTER.UPDATE == true) {
      typeof rowData.value != 'undefined' && this.onRowEdit(rowData.data);
    }
  }

  onRowEdit = (rowData) => {
    this.setState({ transporterMasterId: rowData.transporterMasterId })
    this.props.history.push("/edit-vendor", {
      ...rowData,
      title: "edit_title",
    });
  };

  onRowDelete = (alert) => {
    if (alert.type === "success") this.props.successAlert(alert);
    else this.props.errorAlert(alert);
    this.props.history.push("/vendor");
    this.props.history.go();
  };

  exporDatatFunction = async(data, cancelExportLoading) => {
    window.location.href= `${process.env.REACT_APP_MASTER_API}/transporterMaster/export?customerNumber=${LOCAL_STORAGE.customerNo}&userId=${LOCAL_STORAGE.userId}&authorization=${LOCAL_STORAGE.userToken}`
    cancelExportLoading()
  }

  render() {
    const { rowData } = this.state;
    const { t } = this.props;
    const customerNo = localStorage.getItem('customerNumber')
    const Columns = [
      {
        headerName: t(customerNo != 1158 ? "table_header.vendor_code" : "table_header.partner_code") || "Vendor Code",
        field: "transporterCode",
      },
      {
        headerName:
          t(customerNo != 1158 ? "table_header.vendor_company_name" : "table_header.partner_company_name") || "Vendor Company Name",
        field: "transporterName",
        width: 300,
        cellRendererFramework: (params) => <>
          {params.data.vendorOwnershipType === 1 ? <span className="text-primary p-2">{params.value}</span> : <>{params.value}</>}
        </>

      },
      {
        headerName: t(customerNo != 1158 ? "table_header.vendor_type" : "table_header.partner_type") || "Vendor Type",
        field: "vendorType",
      },
      {
        headerName: t("table_header.pan") || "Pan No.",
        field: "companyPan",
      },

      {
        headerName: t("table_header.email") || "Email",
        field: "transporterEmail",
      },
      ...(canAddRadarAndSpeedUserKeysInVendorMaster ?
        [
          {
            headerName: t("table_header.speed_user_key") || "GPS Tracking Token",
            field: "speedKey",
          },
          {
            headerName: t("table_header.radar_user_key") || "SIM Tracking Token",
            field: "radarKey",
          },
        ] : []
      ),
      /*{
        headerName: t("table_header.mobile_no") || "Mobile No.",
        field: "transporterMobile",
      },
      {
        headerName: t("table_header.status") || "Status",
        field: "transporterStatus",
      }, */
      {
        headerName: t("table_header.created_by") || "Created By",
        field: "createdBy",
      },
      {
        headerName: t("table_header.created_on") || "Created On",
        field: "createdOn",
      },
      {
        headerName: t("table_header.modified_by") || "Modified By",
        field: "updatedBy",
      },
      {
        headerName: t("table_header.modified_on") || "Modified By",
        field: "updatedOn",
      },
      {
        headerName: t("table_header.edit_delete") || "Edit / Delete",
        field: "edit",
        cellRenderer: "actionRenderer",
        suppressToolPanel: true,
        pinned: "right",
        hide: !this.props.permissions.TA_VENDOR_MASTER.UPDATE && !this.props.permissions.TA_VENDOR_MASTER.DELETE,
      },
    ];
    return (
      <React.Fragment>
        <AgGridTable
          isLoading={this.state.loadingData}
          columnDefs={Columns}
          rowData={rowData}
          rowClicked={this.onRowEdit}
          cellDoubleClicked={this.onCellClicked}
          titleBarTitle={t(customerNo != 1158 ? "vendor_title" : "title") || "Vendor"}
          titleBarLink={"/add-vendor"}
          baseURL={"transporterMaster"}
          pathName={"transporterMaster"}
          keyIndex={"transporterMasterId"}
          onEdit={this.onRowEdit}
          hideRowEdit={!this.props.permissions.TA_VENDOR_MASTER.UPDATE}
          hideRowDelete={!this.props.permissions.TA_VENDOR_MASTER.DELETE}
          onDelete={this.onRowDelete}
          transporterMasterId={this.state.transporterMasterId}
          exportHidden={FEATURES.mastersExportDisabled()}
          suppressExcelExport={FEATURES.mastersExportDisabled()}
          suppressCsvExport={FEATURES.mastersExportDisabled()}
          exporDatatFunction = {this.exporDatatFunction}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ permissions }) => {
  return {
    permissions,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    successAlert: (alert) => dispatch(successAlertDispatcher(alert)),
    errorAlert: (alert) => dispatch(errorAlertDispatcher(alert)),
  };
};

export default connect(
  mapStateToProps,
  // null,
  mapDispatchToProps,
)(translate("vendor_list")(Vendor));
